import { FC } from 'react';
import { NotificationTypes, SubscriptionContent, SubscriptionResponse } from '@dynamika-shared/types/subscription';
import { OnSortColumnType } from '@dynamika-shared/ui/Table/Table.types';
import { NotificationTypeHeader } from './NotificationTypeHeader';
import { SubscriptionFilters } from './SubscriptionFilters';
import { SubscriptionsTableView } from './SubscriptionsTable.view';
import { PossibleSubscriptionFilters } from '@restore/clinicalTrialSubscription/subscriptionFilters.types';
import { AllFilters, SelectedFilters, StateFilterItem } from '@components/NestedFilter/types';
import { type MenuInfo } from 'rc-menu/lib/interface';
import { MenuItemType } from '@dynamika-shared/ui/Dropdown/Dropdown';

export type SubscriptionDetailViewProps = {
  selectedNotificationType: NotificationTypes;
  subscriptions: SubscriptionResponse;
  loading: boolean;
  searchValue: string;
  sortBy?: string;
  subFilters: Array<[PossibleSubscriptionFilters, StateFilterItem]>;
  allFilters: AllFilters<PossibleSubscriptionFilters, string>;
  selectedFilters: SelectedFilters<PossibleSubscriptionFilters>;
  filters: MenuItemType[];
  onSearchChange: (value: string) => void;
  onToggleSelectedFilter: (params: { name: PossibleSubscriptionFilters; value: string }) => void;
  onToggleActiveFilter: (key: PossibleSubscriptionFilters) => void;
  onFilterClick: (item: MenuInfo) => void;
  onAddSubscription: () => void;
  onToggleSubscription: (subscription: SubscriptionContent) => void;
  onAction: (action: string, subscription: SubscriptionContent) => void;
  onSort: OnSortColumnType;
  onSubscribeAll: () => void;
  onUnsubscribeAll: () => void;
  onPaginationChange?: (page: number, pageSize: number) => void;
};

export const SubscriptionDetailView: FC<SubscriptionDetailViewProps> = ({
  selectedNotificationType,
  subscriptions,
  loading,
  searchValue,
  sortBy,
  subFilters,
  allFilters,
  selectedFilters,
  filters,
  onSearchChange,
  onToggleSelectedFilter,
  onToggleActiveFilter,
  onFilterClick,
  onAddSubscription,
  onToggleSubscription,
  onAction,
  onSort,
  onSubscribeAll,
  onUnsubscribeAll,
  onPaginationChange,
}) => {
  return (
    <div className='flex-1 p-3'>
      <NotificationTypeHeader
        notificationType={selectedNotificationType}
        onAddSubscription={onAddSubscription}
      />
      <SubscriptionFilters
        subFilters={subFilters}
        allFilters={allFilters}
        selectedFilters={selectedFilters}
        filters={filters}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        onToggleSelectedFilter={onToggleSelectedFilter}
        onToggleActiveFilter={onToggleActiveFilter}
        onFilterClick={onFilterClick}
      />
      <SubscriptionsTableView
        subscriptions={subscriptions}
        loading={loading}
        onToggleSubscription={onToggleSubscription}
        onAction={onAction}
        onSort={onSort}
        sortState={sortBy}
        onSubscribeAll={onSubscribeAll}
        onUnsubscribeAll={onUnsubscribeAll}
        onPaginationChange={onPaginationChange}
      />
    </div>
  );
};
